import { IBannerMessagePayload } from 'src/Common/Models/BannerMessage';
export const Actions = {
  SET_BANNER: 'SET_BANNER',
};

export const setBanner = (payload: IBannerMessagePayload) => (dispatch: any) => {
  dispatch({
    type: Actions.SET_BANNER,
    payload,
  });
};
